import { render, staticRenderFns } from "./UpperPart.vue?vue&type=template&id=e28c2a86&scoped=true&"
import script from "./UpperPart.vue?vue&type=script&lang=js&"
export * from "./UpperPart.vue?vue&type=script&lang=js&"
import style0 from "./UpperPart.vue?vue&type=style&index=0&id=e28c2a86&lang=scss&scoped=true&"
import style1 from "./UpperPart.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28c2a86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
